export default __webpack_public_path__ + "images/f476e1cb7573b4cbeab821414365516b.svg";